export class REDEEM {
    constructor(
        public BID_ID: number,
        public REDEMP_ID: number,
        public ALT_AMT: number,
        public PCENT: number,
        public REDEEM_AMT: number,
        public CREATED_BY: number,
        public ATTACHMENT: string,
        public GROUP_ID: number
    ) { }
}
export class VW_REDEEM {
    constructor(
        public BID_ID: number,
        public REDEEM_ID: number,
        public ALT_AMT: number,
        public SUBREG: string,
        public ACCT_SBN: string,
        public ACCT_BANK: string,
        public REDEEM_AMT: number,
        public TYPE: number,
        public CD_STATUS: string
    ) { }
}
export class REDEEM_INVESTOR {
    constructor(
        public BID_ID: number,
        public REDEMP_ID: number,
        public IDTY_NO: string,
        public INV_ID: number,
        public INV_NAME: string,
        public SERIES_NAME: string,
        public SUBREG_NAME: string,
        public SEC_REK_NO: string,
        public BANK_REK_NO: string,
        public ALT_AMT: number,
        public REDEEM_AMT: number,
        public STAT_REDEEM: string,
        public ATTACHMENT: string,
        public CHECKED: boolean,
        public BID_DATE: string,
        public SELLING_AGENT: string,
        public SID: string,        
        public MAKER: string,
        public BID_CODE:string
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/redeem.ts